export default __webpack_public_path__ + "static/media/RC-HTML-CSS.ccdd4a42.png";